import type { Schema } from '@/api/client'
import { formOf, keyOf, specFor, targetsFor } from './spec'

export type TargetOut = Schema<'PublishTargetOut'>

/**
 * One line for a read-only row: the target's label and its first two text
 * settings — `Git repository · git@github.com:augvanta/site.git · main`.
 * `null` when no target is configured, which the caller renders as its own
 * empty copy.
 */
export function summariseTarget(target: TargetOut, productName: string): string | null {
  if (target.target === null) return null
  const spec = specFor(targetsFor(productName), target.target)
  const values = formOf(spec, target.settings ?? {})
  const shown = spec.fields
    .filter((field) => field.kind === 'text' && field.required === true)
    .map((field) => values[keyOf(field)])
    .filter((value): value is string => typeof value === 'string' && value.trim() !== '')
    .slice(0, 2)
  const credential =
    spec.credentialFree === true || target.credential_set ? [] : ['no credential stored']
  return [spec.label, ...shown, ...credential].join(' · ')
}
